export default class LoginResponse {
    jwt: string;
    persistSession: boolean;
}



// WEBPACK FOOTER //
// ./src/models/LoginResponse.ts